import BaseFoundation from '../base/foundation';
export default class ModalFoundation extends BaseFoundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));

    this.toggleHidden = (hidden, callback) => {
      this._adapter.toggleHidden(hidden, callback);
    };
  }

  destroy() {
    this.afterHide();
  }

  handleCancel(e) {
    this._adapter.notifyCancel(e);
  }

  handleOk(e) {
    this._adapter.notifyOk(e);
  }

  beforeShow() {
    this._adapter.disabledBodyScroll();
  }

  afterHide() {
    this._adapter.enabledBodyScroll();
  }

  afterClose() {
    this._adapter.notifyClose();
  }

}